const exportedObject= {
  OtpInfo: {
    role_privilege: [],
    user_details:[],
    success: false,
    loading: true,
  },
  
};
export default exportedObject;